<template>
  <router-view />
</template>

<script>
import Vue from "vue";
// 套件
import axios from "axios";
import moment from "moment";
// 資料
import Services from "@/data/remote/service.js";
import APIConfig from "@/data/remote/APIConfig.js";
import swHelper from "@/utils/chrome-webpush-helper.js";
import redirectMixin from "@/ui/mixin-redirect.vue";
export default {
  mixins: [redirectMixin],
  computed: {
    logined: () => {
      return true;
    }
  },
  methods: {
    initAxios() {
      const exceptURLs = [APIConfig.APIURL + "/login", APIConfig.APIURL + "/refresh"];
      const isExcept = url => {
        return url.includes("/api") || exceptURLs.indexOf(url) >= 0;
      };

      axios.interceptors.request.use(config => {
        if (isExcept(config.url)) return config;

        let jwt = config.headers["Authorization"].split(".");
        let exp = JSON.parse(atob(jwt[1])).exp;

        config.headers["Content-Encoding"] = "gzip";

        let isNewToken = Math.floor(Date.now() / 1000) < exp - 300;
        if (isNewToken) return config;

        return this.$services.auth.refresh().then(token => {
          if (typeof token === "string") {
            config.headers["Authorization"] = `Bearer ${token}`;
          }
          return config;
        });
      });

      // axios.interceptors.response.use(null, error => {
      // })
    },
    refetchDataForNewNotification(notification) {
      const isAnyTaskUnknown = () => {
        for(let taskIDFromItem in this.$store.getters.taskWorkingItemsMapOfTask) {
          if (!this.$store.getters.tasksMap[taskIDFromItem]) {
            return true
          }
        }
        return false
      }
      const isAnyProjectUnknown = () => {
        for(let projectIDFromTask in this.$store.getters.tasksMapOfProject) {
          if (!this.$store.getters.projectsMap[projectIDFromTask]) {
            return true
          }
        }
        return false
      }

      window.console.log(`refetchDataForNewNotification (${notification.ID})`);
      let todoItem = notification.TodoItem;
      if (todoItem) {
        if (this.$store.getters.myLevel >= 10) {
          this.$store.state.todoItem.isFetched = false;
          this.$services.todoItem.prepareData(this);
        }
      }
      let event = notification.Event;
      window.console.log(event);
      if (!event) return;

      if (event.ItemType == "project") {
        this.$store.state.project.isFetched = false;
        this.$services.project
          .prepareData(this)
          .then(() => (this.$store.state.project.isReloaded = true));
      } else if (event.ItemType == "taskWorkingItem") {
        this.$store.state.taskWorkingItem.isFetched = false;
        this.$services.taskWorkingItem
          .prepareData(this)
          .then(() => (this.$store.state.taskWorkingItem.isReloaded = true))
          .then(() => {
            if (isAnyTaskUnknown()) {
              this.$store.state.task.isFetched = false;
              return this.$services.task.prepareData(this)
            }
          })
          .then(()=>{
            if (isAnyProjectUnknown()) {
              this.$store.state.project.isFetched = false;
              return this.$services.project.prepareData(this)
            }
          });
        // 為了避免收到工作日誌時，員工沒有該工作日誌的專案資訊，確認內容，重新抓取專案/任務。
      } else if (event.ItemType == "task") {
        this.$store.state.task.isFetched = false;
        this.$services.task
          .prepareData(this)
          .then(() => (this.$store.state.task.isReloaded = true))
          .then(()=>{
            if (isAnyProjectUnknown()) {
              this.$store.state.project.isFetched = false;
              return this.$services.project
                .prepareData(this)
            }
          });
      } else if (event.ItemType == "projectDepartmentBudget") {
        this.$store.state.projectDepartmentBudget.isFetched = false;
        this.$services.projectDepartmentBudget
          .prepareData(this)
          .then(
            () => (this.$store.state.projectDepartmentBudget.isReloaded = true)
          );
      } else if (event.ItemType == "user") {
        this.$store.state.user.isFetched = false;
        this.$services.user
          .prepareData(this)
          .then(() => (this.$store.state.user.isReloaded = true));
      } else if (event.ItemType == "county") {
        this.$store.state.county.isFetched = false;
        this.$services.county
          .prepareData(this)
          .then(() => (this.$store.state.county.isReloaded = true));
      } else if (event.ItemType == "client") {
        this.$store.state.client.isFetched = false;
        this.$services.client
          .prepareData(this)
          .then(() => (this.$store.state.client.isReloaded = true));
      } else if (event.ItemType == "department") {
        this.$store.state.department.isFetched = false;
        this.$services.department
          .prepareData(this)
          .then(() => (this.$store.state.department.isReloaded = true));
      } else if (event.ItemType == "announcement") {
        this.$store.state.announcement.isFetched = false;
        this.$services.announcement
          .prepareData(this)
          .then(() => (this.$store.state.announcement.isReloaded = true));
      } else if (event.ItemType == "workOrder") {
        this.$store.state.workOrder.isFetched = false;
        this.$services.workOrder
          .prepareData(this)
          .then(() => (this.$store.state.workOrder.isReloaded = true))
          .then(() => {
            let isAnyUnknownTaskWorkingItem = this.$store.getters.workOrders.findIndex(o => {
              return this.$store.getters.taskWorkingItems.findIndex(o2=>o2.ID == o.TaskWorkingItemID)<0
            }) >= 0
            if (isAnyUnknownTaskWorkingItem) {
              this.$store.state.taskWorkingItem.isFetched = false;
              return this.$services.taskWorkingItem
                .prepareData(this)
            }
          });
      } else if (event.ItemType == "leaveForm") {
        this.$store.state.leaveForm.isFetched = false;
        this.$services.leaveForm
          .prepareData(this)
          .then(() => (this.$store.state.leaveForm.isReloaded = true));
          
        this.$store.state.compensatoryTime.isFetched = false;
        this.$services.compensatoryTime
          .prepareData(this)
          .then(() => (this.$store.state.compensatoryTime.isReloaded = true));
      } else if (event.ItemType == "compensatoryTime") {
        this.$store.state.compensatoryTime.isFetched = false;
        this.$services.compensatoryTime
          .prepareData(this)
          .then(() => (this.$store.state.compensatoryTime.isReloaded = true));
      } else {
        window.console.error(
          `refetchDataForNewNotification, unknown event type ${event.ItemType}`,
          event,
          notification
        );
      }
    },
    putNotificationFromPush(notification) {
      window.console.log(`putNotificationFromPush (${notification.ID})`);
      // window.console.warn(
      //   `app 收到新通知(${notification.ID}). 使用者: ${
      //     notification.UserID
      //   }. 當前使用者: ${this.$store.getters.me &&
      //     this.$store.getters.me.ID}`
      // );
      // 錯的 user
      if (
        (this.$store.getters.me && this.$store.getters.me.ID) !=
        notification.UserID
      ) {
        // window.console.warn(`錯誤的使用者`);
        return;
      }
      // 重複的通知
      let repeatedUnreadNotificationIdx = this.$store.state.notification.unread.list.findIndex(
        o => o.ID == notification.ID
      );
      if (repeatedUnreadNotificationIdx >= 0) {
        // window.console.warn(`重複的通知 unread`, repeatedUnreadNotificationIdx);
        return;
      }

      // 重複的通知
      let repeatedReadedNotificationIdx = this.$store.state.notification.readed.list.findIndex(
        o => o.ID == notification.ID
      );
      if (repeatedReadedNotificationIdx >= 0) {
        // window.console.warn(`重複的通知 readed`, repeatedReadedNotificationIdx);
        return;
      }
      this.$store.state.notification.unread.list.splice(0, 0, notification);
      this.refetchDataForNewNotification(notification);
    },
    initChromePush() {
      if (!swHelper.isBrowserSupportServiceWorker) return;

      const uploadSubscription = () => {
        let payload = {
          DeviceToken: JSON.stringify(
            this.$store.state.deviceInfo.subscription
          ),
          DeviceType: "Chrome"
        };
        this.$services.deviceInfo
          .subscribe(this, payload)
          .catch(window.console.error);
      };

      if (window.BroadcastChannel) {
        const channel = new BroadcastChannel("sw-messages");
        channel.addEventListener("message", event => {
          let notification = event.data;
          window.console.log(`initChromePush: got notification`);
          this.putNotificationFromPush(notification);
        });
      }

      swHelper.onRegistered = () => {
        if (!swHelper.isSubscribed) {
          if (window.confirm("是否開啟推播通知")) {
            window.console.log(
              `APP 要求註冊推播: ${swHelper.applicationServerPublicKey}`
            );
            swHelper.subscribe();
          }
        }
      };
      swHelper.onSubscribed = subscription => {
        this.$store.state.deviceInfo.subscription = subscription;

        // 如果已經登入 上傳 subscription
        if (this.$services.auth.isLogined()) uploadSubscription();

        // 如果還沒登入 登入後上傳 subscription
      };
      swHelper.onUnsubscribed = () => {};
      const publicKey =
        "BBe39d6jGryzqKYmNQCZxZtQLC4KD5uI6cq5G1kUVADz-q-uSY831MgI0qsywA2eFJCn6igLoe_S4cdjvdvmWKk";
      swHelper.initialize(publicKey);
    },
    initAPNS() {
      var self = this;
      const uploadAPNSToken = () => {
        let payload = {
          DeviceToken: this.$store.state.deviceInfo.token,
          DeviceType: "iOS"
        };
        this.$services.deviceInfo
          .subscribe(this, payload)
          .catch(window.console.error);
      };
      const processNotification = notification => {
        window.console.warn(
          `processNotification: swfit 要把資料以json傳遞到javascript，可能有一些型別會跑掉，例如 (go)time.Time -> (js)Date -> (swift)String`
        );
      };
      window.bridge = {
        token: null,
        // swift call javascript
        onReceivedNotification: function(notification) {
          window.console.log("got apns notification", notification);
          self.putNotificationFromPush(notification);
        },
        redirect: function(notification) {
          window.console.log("request redirect to notification", notification);
          self.redirectToNotification(notification);
        },
        setToken: function(token) {
          window.console.log("got APNS token", token);
          window.bridge.token = token;
          // upload
          self.$store.state.deviceInfo.token = token;
          // 如果已經登入 上傳 subscription
          if (self.$services.auth.isLogined()) uploadAPNSToken();
        },
        // call swift
        notifyLoaded: function() {
          try {
            webkit.messageHandlers.callbackHandler.postMessage("loaded");
          } catch (error) {
            // window.console.log(error);
          }
        },
        notifyNotificationReaded: function() {
          try {
            webkit.messageHandlers.callbackHandler.postMessage(
              "notification readed"
            );
          } catch (error) {
            // window.console.log(error);
          }
        },
        get isInIOSWKWebView() {
          var result = false;
          try {
            result =
              webkit &&
              webkit.messageHandlers &&
              webkit.messageHandlers.callbackHandler &&
              webkit.messageHandlers.callbackHandler.postMessage;
          } catch {
            // window.console.log(error);
          }
          return result;
        }
      };
      window.bridge.notifyLoaded();
    },
    // 測試如果把這一段程式放到 NotificationList
    initPollingNewNotifications() {
      var isLoading = false;
      let pollingInterval = 20*1000 // 20秒
      let timer = setInterval(() => {
        // 已經註冊推播就不用
        if (swHelper.isBrowserSupportServiceWorker && swHelper.isSubscribed) return;
        if (this.$store.state.deviceInfo.token) return;
        // 尚未登入就不用
        if (!this.$services.auth.isLogined()) return;
        // 沒有網路就暫停
        if (!window.navigator.onLine) return;
        // 如果都還沒抓過通知，就暫停
        if (this.$services.notification.unreadTS ==null) return;
        // 讀取中就暫停
        if (isLoading) return;
        isLoading = true;
        this.$services.notification
          .getUnread(this)
          .then(res => {
            let newNotifications = res.data.result.notifications;
            window.console.log(
              `polling notification (${newNotifications.length})`
            );
            if (newNotifications.length) {
              this.$store.state.notification.unread.list.splice(
                0,
                0,
                ...newNotifications
              );
            }
            for (let newNotification of newNotifications) {
              this.refetchDataForNewNotification(newNotification);
            }
            return res;
          })
          .finally(() => {
            isLoading = false;
          });
      }, pollingInterval);
    }
  },
  created() {
    this.$vuetify.theme.dark = true;
    Vue.prototype.$services = new Services();
    if (!this.$services.auth.isLogined() && this.$route.name != "login") {
      this.$router.push("login");
    }
    moment.locale("zh-tw");
    this.initAxios();

    let jwt = this.$services.auth.getJWT();
    if (jwt) {
      this.$store.state.myID = JSON.parse(atob(jwt.split(".")[1])).ID;
      axios.defaults.headers["Authorization"] = `Bearer ${jwt}`;
    }
    this.initChromePush();
    this.initAPNS();
    this.initPollingNewNotifications();
  }
};
</script>